import { useCallback } from 'react';
import { m } from 'framer-motion';
// @mui
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
// locales
import { useLocales } from 'src/locales';
// components
import Iconify from 'src/components/iconify';
import { varHover } from 'src/components/animate';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import globe from './globe.png'
import { Box } from '@mui/material';
import { useSettingsContext } from 'src/components/settings';
// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const locales = useLocales();

  const settings = useSettingsContext();


  const popover = usePopover();

  const handleChangeLang = useCallback(
    (newLang) => {
      locales.onChangeLang(newLang);
      popover.onClose();
    },
    [locales, popover]
  );

  return (
    <Box
      component={m.div}
      // animate={{
      //   rotate: [0, settings.open ? 0 : 360],
      // }}
      transition={{
        duration: 12,
        ease: 'linear',
        repeat: Infinity,
      }}
    >

      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          ...(popover.open && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        {/* <img alt='icon' src={globe} width={'35rem'} style={{ borderRadius: 0.65 }} /> */}
        <Iconify icon={'iconoir:language'} color="#7955CF" width={27} />
      </IconButton>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 170, maxHeight: 700, overflow: 'scroll' }}>
        {locales.allLangs.map((option) => (
          <MenuItem
            sx={{ display: 'flex', justifyContent: 'space-between' }}
            key={option.value}
            selected={option.value === locales.currentLang.value}
            onClick={() => handleChangeLang(option.value)}
          >
            {/* <Iconify icon={option.icon} width={28} sx={{ borderRadius: '.5rem' }} /> */}

            {/* <span style={{fontWeight : [500]}}>{option.label}</span> */}
            <span style={{fontWeight : [500]}}>{option.subLabel}</span>
          </MenuItem>
        ))}
      </CustomPopover>
    </Box>

  );
}
